// @flow

export const closestIndex = (number: number, offsetArr: Array<number>): number => {
    let middle;
    let low = 0;
    let high = offsetArr.length - 1;
    while (high - low > 1) {
        middle = Math.floor((low + high) / 2);
        if (offsetArr[middle] < number) {
            low = middle;
        } else {
            high = middle;
        }
    }
    if (number - offsetArr[low] <= offsetArr[high] - number) {
        return low;
    }
    return high;
};
